import {
  isScreenerV2DashboardPath,
  isTalentDiscoveryPublicPath,
} from './global-ai-assistant-route-filter-kind';

function isDashboardFilterPath(pathname: string): boolean {
  const parts = pathname.split('/').filter(Boolean);
  const [entity, page] = parts;
  if (page === undefined) {
    return false;
  }
  return entity === 'company' || entity === 'geography' || entity === 'role';
}

function isGenericCustomDashPath(pathname: string): boolean {
  const parts = pathname.split('/').filter(Boolean);
  return parts[0] === 'custom-dash' && parts[1] !== undefined;
}

export function isGlobalAssistantFilterApplyCapablePath(
  pathname: string
): boolean {
  return (
    isTalentDiscoveryPublicPath(pathname) ||
    isScreenerV2DashboardPath(pathname) ||
    isDashboardFilterPath(pathname) ||
    isGenericCustomDashPath(pathname)
  );
}
